import type { Operator, ParsedToken } from '../../../types/QueryBuilder';

import { removeToken, replaceToken, stringifyToken } from './tokenString';

export type FilterTokenNode = Extract<ParsedToken, { type: 'FILTER' }>;

export function findFilterToken(parsedQuery: ParsedToken[], field: string): FilterTokenNode | undefined {
  return parsedQuery.find((t): t is FilterTokenNode => t.type === 'FILTER' && t.field === field);
}

export interface FilterWrite {
  field: string;
  operator: Operator;
  values: Array<string | number | boolean>;
}

export function setFilterInQuery(
  query: string,
  parsedQuery: ParsedToken[],
  { field, operator, values }: FilterWrite,
  existingToken?: FilterTokenNode,
): string {
  const existing = existingToken ?? findFilterToken(parsedQuery, field);
  if (values.length === 0) {
    return existing ? removeToken(query, existing) : query;
  }
  const replacement = stringifyToken({
    type: 'FILTER',
    field,
    operator,
    value: values.length === 1 ? values[0] : values,
    text: '',
    location: { start: { offset: 0 }, end: { offset: 0 } },
  });
  return existing ? replaceToken(query, existing, replacement) : query ? `${query} ${replacement}` : replacement;
}
